import React from 'react';
import imageShax from "./image_2023-10-03_17-01-45.png"


let mySkills = ["HTML5","CSS3","JavaScript","ReactJs","npm","Git","Bootstrap","SASS","UI Design"]

const Aboutme = () => {
    return ( 
        <div className='about_me' name='aboutme'>
            <div className='img_text_aboutMe'>
                <div className='img_aboutMe' data-aos="zoom-in-right">
                    <img src={imageShax} />
                </div>
                <div className='right_text_aboutMe'>
                    <h1 data-aos="zoom-in-left"><span>Nice to meet you,</span><br/> I am Shakhriddin Achilov</h1>
                    <p data-aos="zoom-in-left">Working full time in React, Typescript and SCSS, leading the team for revamping DotCMS administration system.</p>
                    <h2 data-aos="zoom-in-left">Code, Design, Learn and Teach.</h2>
                    <p data-aos="zoom-in-left">Frontend is my true passion and I really enjoy the whole process of creating UIs, from the first brainstorming, wireframes, mockups, design, all the way until the final product.</p>
                </div>
            </div>
            <div className='expiriense_skill'>
                <h1>My experience includes but not limited</h1>
                <div className='skills'>
                    {
                        mySkills.map(mySkill=>{
                            return(
                                <p>{mySkill}</p>
                            )
                        })
                    }
                </div>
            </div>
        </div>
     );
}
 
export default Aboutme;